<template>
  <NuxtLink :to="`/stories/${story.id}/`">
    <div class="flex items-center bg-dark-bg-default">
      <OptimizedImage alt="" :class="['h-[160px] md:h-[280px]']" :image-url="story.mainImage.url" :optimized-image-options="{ width: 560 }" />
      <div class="flex flex-col gap-2 p-4">
        <div class="flex flex-1 flex-col items-start justify-center gap-2 self-stretch">
          <AtomsHeading3 class="line-clamp-3 text-dark-fg-emphasis md:text-xl">{{ story.title }} </AtomsHeading3>
          <p class="line-clamp-1 text-xs leading-4 text-dark-fg-default md:text-base" :to="`/stories/${story.id}`">{{ story.provider.name }}</p>
        </div>
        <div class="flex w-full justify-end text-right">
          <p class="text-xs text-gray8 md:text-base">View More</p>
        </div>
      </div>
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import { OptimizedImage } from '@/wabunka-src/common/components';
import type { StoryViewModel } from '@/wabunka-src/features/Story';

interface Props {
  story: StoryViewModel;
}
defineProps<Props>();
</script>
